/**
 *
 * @param {function} conditionFn
 * @param {number} [ms]
 * @param {number} [limit]
 * @returns {Object}
 */
$.intervalWhile = function intervalWhile(conditionFn, ms = 1000, limit = 1000) {
    /**
     * @type {number}
     */
    let intervalId;
    let attempts = 0;

    const def = $.Deferred();
    const promise = def.promise();

    const cancel = function cancel() {
        clearInterval(intervalId);
    };

    intervalId = setInterval(function interval() {
        const isConditionBroke = !conditionFn();
        const isLimitReached = ++attempts >= limit;

        if (isConditionBroke || isLimitReached) {

            if (isConditionBroke) {
                def.resolve()
            }

            else if (isLimitReached) {
                def.reject();
            }

            cancel();
        }
    }, ms);

    return {
        cancel,
        intervalId,
        reStart() {
            cancel();

            return intervalWhile(conditionFn, ms, limit);
        },
        promise
    }
};



// WEBPACK FOOTER //
// ./js/main/plugin/interval-while.js